




































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ChannelGroupItemTypeStyles, PostTypeStyle, GroupSettings, ChannelGroupBehavior, TransitionTypes, ChannelGroup, InteractionTypes, ChannelStyleTypes } from "@/services/channels/types";
import { GetLocalizedStyleableTypes, postTypes } from "@/components/posts/PostTypeRegister";
import i18n from "@/i18n";
import { Style, ChannelStyle } from "@/services/styles/types";
import { settingsValidators } from "@/components/channels/validators";
import validate from "@/directives/validate";
import { postTypesFields } from "@/components/channels/fields/postTypesFields";
import vSelect from "vue-select";

@Component({
    components: {
        vSelect
    },
    directives: {
        validate
    }
})
export default class ChannelGroupSettings extends Vue {
    @Prop() settings!: ChannelGroup;
    @Prop() styles!: Style[];
    @Prop() postTypeStyles!: PostTypeStyle[];
    @Prop() collapseState!: boolean;
    @Prop() menuStyles!: ChannelStyle[];
    @Prop() durationStyles!: ChannelStyle[];
    @Prop() counterStyles!: ChannelStyle[];

    // local state
    localCollapseState = true;
    localSettings = {} as ChannelGroup;
    fields = postTypesFields;
    validators = settingsValidators;
    intTypes = InteractionTypes;

    transitionTypes: any = Object.keys(TransitionTypes)
        .map(key => ({ name: i18n.t(`channels.${key}`), id: key }));

    interactionTypes: any = Object.keys(InteractionTypes).map(key => ({
        name: i18n.t(`channels.${key}`),
        id: key
    }));

    defaultTransitionTime = 300;

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
        this.localSettings = this.settings;
    }

    // Watchers
    @Watch("settings")
    onPropertyChanged() {
        this.localSettings = this.settings;
    }

    // computed
    get channelItemTypes(): ChannelGroupItemTypeStyles[] {
        const array = [] as ChannelGroupItemTypeStyles[];

        Object.keys(postTypes).forEach(key => {
            const item = {
                postTypeName: i18n.t(`posts.${key}`),
                value: key,
                styleId: "",
                selected: this.postTypeStyles && this.postTypeStyles.some(item => item.postType === key),
                styleable: GetLocalizedStyleableTypes().some(item => item.value === key),
                styleOptions: this.filteredStyles(key)
            } as unknown as ChannelGroupItemTypeStyles;
            if (item.selected) {
                item.styleId = this.postTypeStyles.filter(
                    item => item.postType === key
                )[0].styleId;
            }

            array.push(item);
        });
        return array;
    }

    get localizedBehaviorOptions() {
        return Object.keys(ChannelGroupBehavior).map(enumKey => ({
            value:
                ChannelGroupBehavior[enumKey as keyof typeof ChannelGroupBehavior],
            text: i18n.t(`channelGroups.${enumKey.toLowerCase()}`)
        }));
    }

    get renderTransitionTime(): boolean {
        const showTransitionTime = this.localSettings.transitionType !== "none";
        if (showTransitionTime) {
            this.localSettings.transitionTime = this.settings.transitionTime !== undefined && this.settings.transitionTime > 0 ? this.settings.transitionTime : this.defaultTransitionTime;
        }
        return showTransitionTime;
    }

    // methods

    setStyle(item: any) {
        this.channelItemTypes.forEach(x => {
            if (x === item) {
                x.selected = true;
            } else if (x.styleId === "") {
                x.selected = false;
            }
        });
    }

    filteredStyles(postType: string): Style[] {
        const sc = this.styles.filter(option => option.postType === postType);
        sc.unshift({
            id: "",
            name: i18n.t(`channels.selectStyles`) as string,
            postType: "",
            css: ""
        } as Style);
        return sc;
    }

    getSelectedData(): PostTypeStyle[] {
        return this.channelItemTypes
            .filter(option => option.selected)
            .map(x => ({
                postType: x.value,
                styleId: x.styleId
            }));
    }

    emitData() {
        this.localSettings.postTypeStyles = this.getSelectedData();
        // deep copy to avoid binding
        this.$emit("settingsUpdated", JSON.stringify({
            settings: this.localSettings
        }));
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "ChannelGroupSettings", state: state });
    }

    goToStyle(id: string) {
        return { name: "updatestyle", params: { styleId: id } };
    }

    channelStylesUpdateRoute(styleId: string) {
        if (!styleId) return "#";
        return {
            name: "updateChannelStyles",
            params: { styleId: styleId }
        };
    }
}
